import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';

import Button from '../../../shared/_TBComponents/Button';

import iconSet from '../../../shared/images/teambuildr-selection.json';

const ZeroStateWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 40px 20px;
`;

const ZeroStateCard = styled('div')`
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
  padding: 48px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 560px;
  width: 100%;
  text-align: center;
`;

const PodiumIllustration = styled('div')`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-bottom: 28px;
`;

const PodiumColumn = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
`;

const MedalCircle = styled('div')`
  width: 52px;
  height: 52px;
  background: white;
  border-radius: 50%;
  border: 2px solid ${({ borderColor }) => borderColor};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PodiumBar = styled('div')`
  width: 90px;
  height: ${({ height }) => height}px;
  background: ${({ bgColor }) => bgColor};
  border-radius: 6px 6px 0 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 12px;
  color: white;
  font-family: 'Nunito Sans';
  font-size: 20px;
  font-weight: 700;
`;

const ZeroStateHeading = styled('p')`
  font-family: 'Nunito Sans';
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 12px;
  line-height: 1.4;
`;

const ZeroStateSubtext = styled('p')`
  font-family: 'Nunito Sans';
  font-size: 14px;
  color: #6b7280;
  max-width: 400px;
  margin: 0 0 32px;
  line-height: 1.6;
`;

const LeaderboardZeroState = ({
  heading, subtext, buttonLabel, onButtonClick,
}) => (
  <ZeroStateWrapper>
    <ZeroStateCard>
      <PodiumIllustration>
        <PodiumColumn>
          <MedalCircle borderColor='#979797'>
            <IcomoonReact iconSet={iconSet} size={22} icon='ribbon' color='#979797' />
          </MedalCircle>
          <PodiumBar height={80} bgColor='rgba(23, 135, 251, 0.6)'>2</PodiumBar>
        </PodiumColumn>
        <PodiumColumn>
          <MedalCircle borderColor='#f9b242'>
            <IcomoonReact iconSet={iconSet} size={22} icon='trophy' color='#f9b242' />
          </MedalCircle>
          <PodiumBar height={110} bgColor='rgba(23, 135, 251, 1)'>1</PodiumBar>
        </PodiumColumn>
        <PodiumColumn>
          <MedalCircle borderColor='#d0740d'>
            <IcomoonReact iconSet={iconSet} size={22} icon='ribbon' color='#d0740d' />
          </MedalCircle>
          <PodiumBar height={60} bgColor='rgba(23, 135, 251, 0.35)'>3</PodiumBar>
        </PodiumColumn>
      </PodiumIllustration>
      <ZeroStateHeading>{heading}</ZeroStateHeading>
      <ZeroStateSubtext>{subtext}</ZeroStateSubtext>
      <Button
        name={buttonLabel}
        bgColor='#444444'
        txtColor='white'
        noBorder
        customBorderRadius='8px'
        styledTextProps={{ fontWeight: 700, fontSize: 14, letterSpacing: '0px' }}
        styledWrapperProps={{ height: '40px', padding: '0 20px' }}
        onClick={onButtonClick}
      />
    </ZeroStateCard>
  </ZeroStateWrapper>
);

LeaderboardZeroState.propTypes = {
  heading: PropTypes.string.isRequired,
  subtext: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

export default LeaderboardZeroState;
